import { APP_POOL_CONFIG } from '@synergy/config';

import { receiptInternalNotesSelector } from '../../selectors/internal-notes-selectors';
import { useAppSelector } from '../../../store/use-appstate-selector';

export interface CompletionWarningInput {
    /** The tax rates on the document's positions. */
    taxes?: number[];
    /** The country of the invoice address, spelled out as the document has it. */
    invoiceLocation?: string;
}

/**
 * What a reader has to take note of before a document may be completed (#2132).
 *
 * Two things stand in the way: an internal note nobody has answered, and a tax
 * rate that does not fit the invoice address. Both checks are carried over
 * unchanged from the completion modal they used to live in — the same
 * questions, now asked in one place for every document.
 *
 * Returns the translation ids of the open points, in reading order.
 */
export const useCompletionWarnings = ({ taxes, invoiceLocation }: CompletionWarningInput): string[] => {
    const notes = useAppSelector(receiptInternalNotesSelector);
    const country = APP_POOL_CONFIG.address.country;

    const warnings: string[] = [];

    if (notes.length > 0) {
        warnings.push('app.receipt.modal.internalNotes.accept');
    }

    if ('AT' === country && taxes?.some(tax => 0 === tax) && 'Österreich' === invoiceLocation) {
        warnings.push('app.receipt.modal.taxes.atTaxRateWithAtAddress');
    } else if ('AT' === country && taxes?.some(tax => 0 !== tax) && 'Österreich' !== invoiceLocation) {
        warnings.push('app.receipt.modal.taxes.atTaxRateWithOtherAddress');
    } else if ('CH' === country && taxes?.some(tax => 0 !== tax) && 'Schweiz' !== invoiceLocation) {
        warnings.push('app.receipt.modal.taxes.chTaxRateWithOtherAddress');
    }

    return warnings;
};
